export default __webpack_public_path__ + "static/media/authorize.e20a72b9.png";